import * as textHelpers from 'app/utils/text/helpers'

interface Option {
  label: string
  value: string
}

export const rentFrequencyOptions: Option[] = [
  { label: 'Allow applicant to choose', value: 'open' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Fortnightly', value: 'fortnightly' },
  { label: 'Monthly', value: 'monthly' },
]

export const preApplyViewingOptions: Option[] = [
  { label: 'Physical', value: 'physical' },
  { label: 'Virtual', value: 'virtual' },
  { label: 'Virtual or Physical', value: 'physical-or-virtual' },
]

export const rentFrequencyOpenOption: string = rentFrequencyOptions[0]!.value
export const rentFrequencyDefaultValue: string = rentFrequencyOpenOption
export const rentFrequencyDBKey: string = 'rent_frequency'

export const preApplyViewingPhysicalOption: string =
  preApplyViewingOptions[0]!.value
export const preApplyViewingOptionDBKey: string = 'viewing_checkin_require_type'

interface ApplicationText {
  [key: string]: string
}

export const EMPLOYMENT_HISTORY_HEADER_KEY = 'employment-history-header'
export const ADD_EMPLOYMENT_HISTORY_HEADER_KEY = 'add-employment-history-header'
export const TOTAL_INCOME_EXTRA_TEXT_KEY = 'total-income-extra-text'
export const idDocsTitle = 'id-docs-title'
export const incomeHeaderGuidance = 'income-header-guidance'
export const incomePayslipsGuidance = 'income-payslips-guidance'
export const incomeBankStatement = 'income-bank-statement'
export const incomeGorvenmentBenefitTicked = 'income-gorvenment-benefit-ticked'
export const petsTitle = 'pets-title'
export const petsNameTitle = 'pets-name-title'
export const petsBreedTitle = 'pets-breed-title'
export const petsIdentifyingTitle = 'pets-identifying-title'
export const petsAttachmentTitle = 'pets-attachment-title'
export const petAttachmentsSubtext = 'pet-attachments-subtext'

export const qldApplicationText: ApplicationText = {
  [EMPLOYMENT_HISTORY_HEADER_KEY]: textHelpers.EMPLOYMENT_HISTORY_HEADER_FORM22,
  [ADD_EMPLOYMENT_HISTORY_HEADER_KEY]:
    textHelpers.ADD_EMPLOYMENT_HISTORY_HEADER_FORM22,
  [TOTAL_INCOME_EXTRA_TEXT_KEY]: textHelpers.TOTAL_INCOME_EXTRA_TEXT_FROM22,
  [idDocsTitle]:
    'Please provide two documents to verify your identity (note: if you are unsuccessful these ID documents will be destroyed within 3 months).',
  [incomeHeaderGuidance]: textHelpers.INCOME_HEADER_GUIDANCE_QLD,
  [incomePayslipsGuidance]: textHelpers.INCOME_PAYSLIPS_COUNT_RECOMMEND_QLD,
  [incomeBankStatement]: textHelpers.BANK_STATEMENT_TEXT_PROFILE_PAGE_QLD,
  [incomeGorvenmentBenefitTicked]: textHelpers.GORVERNMENT_BENEFIT_TICKED_QLD,
  [petsTitle]: `I don’t have any pets that will be kept at the property`,
  [petsNameTitle]: `Name (optional)`,
  [petsBreedTitle]: `Breed (optional)`,
  [petsIdentifyingTitle]: `Identifying features (optional e.g. sex, fur/colour, other features):`,
  [petsAttachmentTitle]: `Attach a photo and pet references (optional)`,
  [petAttachmentsSubtext]: ``,
}

export const defaultApplicationText: ApplicationText = {
  [EMPLOYMENT_HISTORY_HEADER_KEY]:
    textHelpers.EMPLOYMENT_HISTORY_HEADER_GUIDANCE,
  [ADD_EMPLOYMENT_HISTORY_HEADER_KEY]:
    textHelpers.ADD_EMPLOYMENT_HISTORY_HEADER,
  [TOTAL_INCOME_EXTRA_TEXT_KEY]: textHelpers.TOTAL_INCOME_EXTRA_TEXT,
  [idDocsTitle]:
    'Add a current Primary ID with a photo to verify your identity & Snug profile. Note a Passport and Drivers Licence is required if you choose to add a Background Check.',
  [incomeHeaderGuidance]: textHelpers.INCOME_HEADER_GUIDANCE,
  [incomePayslipsGuidance]: textHelpers.INCOME_PAYSLIPS_COUNT_RECOMMEND,
  [incomeBankStatement]: textHelpers.BANK_STATEMENT_TEXT_PROFILE_PAGE,
  [incomeGorvenmentBenefitTicked]: textHelpers.GORVERNMENT_BENEFIT_TICKED,
  [petsTitle]: `I don't have any pets`,
  [petsNameTitle]: `Name`,
  [petsBreedTitle]: `Breed`,
  [petsIdentifyingTitle]: `Identifying features (eg. sex, fur/colour, other features):`,
  [petsAttachmentTitle]: `Attach a photo and pet reference`,
  [petAttachmentsSubtext]: `Attach a photo of the pet, pet reference, photo of enclosure, medical exemption from microchipping etc.`,
}
